module.exports = __webpack_public_path__ + "img/zhongguopingan.ab32e36f.png";